module.exports = __webpack_public_path__ + "static/media/093-add button.beace05b.svg";